module.exports = __webpack_public_path__ + "static/media/pardes_headshot.e7b9cc40.png";